import Vue from 'vue';
import Vuex from 'vuex';
import createAuth, { getInitialState as getAuthInitialState } from './modules/auth';
import createContent, { getInitialState as getContentIntialState } from './modules/content';

Vue.use(Vuex);


export async function getInitialState() {
  const authPromise = getAuthInitialState();
  const contentPromise = getContentIntialState();
  return {
    auth: await authPromise,
    content: await contentPromise,
  };
}

export default ({ auth, content }) => new Vuex.Store({
  modules: {
    auth: createAuth(auth),
    content: createContent(content),
  },
});
